import { ODTeamBoundary } from 'ODTeamBoundary';
import React from 'react';
import { DynamicDisclosuresWizard } from 'sellDirect/components/closingDash/disclosures/DynamicDisclosures/DynamicDisclosuresWizard';
import { StaticDisclosuresWizard } from 'sellDirect/components/closingDash/disclosures/StaticDisclosuresWizard';
import { ClosingTasks } from 'sellDirect/helpers/closingTasks';
import { shouldSeeNewDisclosureFlowFeature } from 'sellDirect/helpers/experiments';
import { UnderContractOffer } from 'sellDirect/OfferContext';
export interface DisclosuresWizardProps {
  offer: UnderContractOffer;
  closingTasks: ClosingTasks;
  isEnhancedDisclosureFlowEnabled: boolean;
}

/**
 * Renders disclosures form based on feature flag
 * component-test-check-ignore
 * storybook-check-ignore
 */
export const DisclosuresWizard: React.FC<DisclosuresWizardProps> = ({
  offer,
  closingTasks,
  isEnhancedDisclosureFlowEnabled,
}) => {
  const shouldSeeEnhancedDisclosureFlow = shouldSeeNewDisclosureFlowFeature(
    offer.sentAt,
    isEnhancedDisclosureFlowEnabled,
  );

  return shouldSeeEnhancedDisclosureFlow ? (
    <ODTeamBoundary team="listings">
      <DynamicDisclosuresWizard offer={offer} />
    </ODTeamBoundary>
  ) : (
    <StaticDisclosuresWizard offer={offer} closingTasks={closingTasks} />
  );
};
